import React from "react";

import { Skeleton } from "antd";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  card: {
    width: "100%",
    backgroundColor: "white",
    borderRadius: 10,
    padding: 20,
    marginRight: 10,
  },
});

const GridLoading = () => {
  const styles = useStyles();

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        flexDirection: "column",
      }}
    >
      <div className={styles.card}>
        <Skeleton active />
      </div>

      <div className={styles.card}>
        <Skeleton active />
      </div>

      <div className={styles.card}>
        <Skeleton active />
      </div>

      <div className={styles.card}>
        <Skeleton active />
      </div>
    </div>
  );
};

export default GridLoading;
